import { DashboardPeriodPreset, IVisitPeriod } from "../types/ownerDashboard.types";

export interface PropertyAnalyticsQuery {
  periodPreset: DashboardPeriodPreset;
  customPeriod?: IVisitPeriod | null;
  propertyId?: number | null;
}

export function buildPropertyAnalyticsParams(
  query: PropertyAnalyticsQuery
): Record<string, string> {
  const params: Record<string, string> = {};

  if (query.customPeriod) {
    params.initial_date = query.customPeriod.initial_date;
    params.final_date = query.customPeriod.final_date;
  } else {
    params.period = query.periodPreset;
  }

  if (query.propertyId != null) {
    params.property_id = String(query.propertyId);
  }

  return params;
}
